const paylaterRoute = {
  KELOLA_PENGELUARAN: '/expenses',
}

export default paylaterRoute
